module.exports = __webpack_public_path__ + "img/republic-of-macedonia.5632011e.svg";